<nb-card class="main-card">
  <nb-card-header> <nb-icon icon="alert-circle-outline"></nb-icon> REQUEST INFORMATION</nb-card-header>
  <nb-card-body class="main-card-body">
    <button nbButton status="success" (click)="onCustomerInfoClick()">CUSTOMER INFORMATION</button>
    <button nbButton status="info" (click)="onAppointmentInfoClick()">APPOINTMENT INFORMATION</button>
    <div class="main-grid">
      <nb-card accent="warning" *ngFor="let item of dataSource; index as i" class="item-wrapper">
        <nb-card-header>
          <div class="item-time">{{ item.createdAt | timeago }}</div>
        </nb-card-header>
        <nb-card-body>
          <div class="item-status text-center">
            <span *ngIf="item.status === 'waiting for response'" class="tag-color tag-color--warning blink"
              >waiting for response</span
            >
            <span *ngIf="item.status === 'skipped'" class="tag-color tag-color--danger">skipped</span>
            <span *ngIf="item.status === 'no response'" class="tag-color tag-color--info">no response</span>
          </div>
          <div *ngIf="item.respondedAt">
            <div *ngIf="item.type === TYPE.APPOINTMENT_INFO">
              <ul>
                <li><label>Phone number:</label> {{ item.phoneNumber | PhoneNumberPipe }}</li>
                <li><label>First name:</label> {{ item.customer?.firstName || item.firstName }}</li>
                <li><label>Last name:</label> {{ item.customer?.lastName || item.lastName }}</li>
                <li><label>Time:</label> {{ item.formattedDate }}, {{ item.formattedTime }}</li>
              </ul>
            </div>
            <div *ngIf="item.type === TYPE.CUSTOMER_INFO || item.type === TYPE.SELL_GIFT_CARD_INFO">
              <ul>
                <li><label>Phone number:</label> {{ item.phoneNumber | PhoneNumberPipe }}</li>
                <li><label>First name:</label> {{ item.customer?.firstName || item.firstName }}</li>
                <li><label>Last name:</label> {{ item.customer?.lastName || item.lastName }}</li>
              </ul>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton class="right-button" (click)="onCancel()"><nb-icon icon="close-outline"></nb-icon>CLOSE</button>
  </nb-card-footer>
</nb-card>
